import React from 'react';
import PropTypes from 'prop-types';
import { Handle } from 'rc-slider';
import { isNumber } from 'lodash';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { CurrencyFormats } from '@sm360/widget-commons-vehicle';

import './HandleWithTooltip.scss';

const generateHandleWithTaxSavings = (taxSavings, roundedValue) => {
    const HandleWithTooltip = ({ value, index, min, max, ...restProps }) => {
        return (
            <Handle id="tooltip" value={value} {...restProps}>
                <div className="tooltip-text">
                    <span className="is-bold" data-test="trade-in.handle-with-tooltip.value">
                        {LocaleService.l(roundedValue, CurrencyFormats.CURRENCY_0)}
                    </span>
                    {isNumber(taxSavings) && (
                        <span className="tooltip-tax">
                            {`+ ${LocaleService.l(taxSavings, CurrencyFormats.CURRENCY_0)}`}
                        </span>
                    )}
                </div>
            </Handle>
        );
    };

    HandleWithTooltip.propTypes = {
        value: PropTypes.string.isRequired,
        index: PropTypes.number.isRequired,
        min: PropTypes.number.isRequired,
        max: PropTypes.number.isRequired,
    };

    HandleWithTooltip.displayName = 'HandleWithTooltip';

    return HandleWithTooltip;
};

export default generateHandleWithTaxSavings;



// WEBPACK FOOTER //
// ./src/components/EstimateTradeIn/components/Slider/HandleWithTooltip.jsx